import { apiClient } from "../../base/ApiClient";

// Visit Plan Apis
export const getVisitPlan = async (
  page,
  client,
  career,
  location,
  area,
  fromDate,
  toDate,
  is_assigned
) => {
  const params = new URLSearchParams();

  // Always include page
  params.append("page", page);

  // Conditionally add parameters only if they are not empty
  if (client) params.append("client", client);
  if (career) params.append("career", career);
  if (location) params.append("location", location);
  if (area) params.append("area", area);
  if (fromDate) params.append("from_date", fromDate);
  if (toDate) params.append("to_date", toDate);
  if (is_assigned) params.append("is_assigned", is_assigned);

  const response = await apiClient.get(
    `schedule/visits/visit-plan/?${params.toString()}`
  );
  return response.data;
};

export const getVisitTimeline = async (
  page,
  client,
  career,
  location,
  area,
  fromDate,
  toDate,
  status,
  date
) => {
  const params = new URLSearchParams();

  params.append("page", page);

  if (client) params.append("client", client);
  if (career) params.append("career", career);
  if (location) params.append("location", location);
  if (area) params.append("area", area);
  if (fromDate) params.append("from_date", fromDate);
  if (toDate) params.append("to_date", toDate);
  if (status) params.append("status", status);
  if (date) params.append("date", date);

  const response = await apiClient.get(
    `/schedule/timeline/?${params.toString()}`
  );
  return response.data;
};